export const aboutData = {
    title: "Who I am",
    description1: `Enthusiastic and passionate aspiring Full Stack Web
    Developer with a specialization in MERN stack. Curious
    to work on challenging projects by being resourceful,
    innovative, and flexible. Seeking a position in an
    organization where I would get ample opportunities to
    utilize my skills and abilities. `,
    description2: "",
    image: 2
}